import DataModel from "./DataModel";

class RuleActionType extends DataModel {
	constructor() {
		super('rules/actions/types')
	}
}

export default RuleActionType;
